import { render, staticRenderFns } from "./speaker.vue?vue&type=template&id=f20d242e&scoped=true&"
import script from "./speaker.vue?vue&type=script&lang=js&"
export * from "./speaker.vue?vue&type=script&lang=js&"
import style0 from "./speaker.vue?vue&type=style&index=0&id=f20d242e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20d242e",
  null
  
)

export default component.exports